/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import SignupEmailFormDumb from './SignupEmailFormDumb';
import { selectSignupEmail } from 'src/shared/app/signup/selector/appSignupSelector';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  handleSubmit: (Object) => Promise<any>,
};

const mapStateToProps = (state: State, { handleSubmit }: Props): Object => ({
  handleSubmit,
  email: selectSignupEmail(state),
});

export default compose(connect(mapStateToProps))(SignupEmailFormDumb);
